import { useEffect, useState } from "react";
import { setFunctionData } from "../../store/functionStore";

export function Modal() {
  //  STATES
  const BEFORE_INIT = "beforeInit";
  const NOT_DISPLAY = "notDisplay";
  const DISPLAY = "display";

  const [state, setState] = useState(BEFORE_INIT);

  //ローカルデータ
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  useEffect(() => {
    if (state == BEFORE_INIT) {
      setFunctionData("displayModal", displayModal);
      setFunctionData("deleteModal", deleteModal);
      setState(NOT_DISPLAY)
      return;
    }
    if (state == NOT_DISPLAY) {
      setTitle("");
      setBody("");
      return;
    }
    if (state == DISPLAY) {
      return;
    }
    console.error(`Modalにて不可能なstate:${state}になりました`);
  }, [state]);

  function displayModal(title, body) {
    setTitle(title);
    setBody(body);
    setState(DISPLAY);
  }

  function deleteModal() {
    setState(NOT_DISPLAY);
  }

  return (
    <div>
    {state === DISPLAY && (<div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor:"#cccccc99"
      }}
      onClick={() => deleteModal()}
    >
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "#cacaca",
            width: "30%",
            height: "30%",
            margin: "auto",
            border: "3px solid black",
            borderRadius: 10,
          }}
        >
            <div
              style={{
                fontSize: 28,
                textAlign: "center",
                width: "100%",
              }}
            >
              {title}
            </div>
            <div
              style={{
                fontSize: 18,
                whiteSpace: "pre-line",
              }}
            >
              {body}
            </div>
        </div>
    </div>)}</div>
  );
}
